import { DataBean } from "../DataBean";

export class SupplierPaymentOrderItem extends DataBean {

    public async addPaymentOrderItem(idSupplierPaymentOrder: number, supplierPaymentOrderDate: any, idAdquisitionArticle: number, idBudgetType: number, idBudgetResource: number, idBudgetSource: number, value: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.supplier.SupplierPaymentOrderItem_addPaymentOrderItem_Number_java.util.Date_Number_Number_Number_Number_Number",
            [idSupplierPaymentOrder, supplierPaymentOrderDate, idAdquisitionArticle, idBudgetType, idBudgetResource, idBudgetSource, value]);
    }

    public async addPaymentOrderItemFromRP(idSupplierPaymentOrder: number, supplierPaymentOrderDate: any, budgetIDStr: string, idBudgetResource: number, idBudgetSource: number, value: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.supplier.SupplierPaymentOrderItem_addPaymentOrderItemFromRP_Number_java.util.Date_String_Number_Number_Number",
            [idSupplierPaymentOrder, supplierPaymentOrderDate, budgetIDStr, idBudgetResource, idBudgetSource, value]);
    }

    public async deleteSupplierPaymentOrderItem(idSupplierPaymentOrderItem: any, since: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSupplierPaymentOrderItem_Number_java.util.Date_Number", [idSupplierPaymentOrderItem, since, idEmployee]);
    }

    public async getSupplierPaymentOrderItemCatalogForAdquisitionContract(idSupplierPaymentOrder: number, supplierPaymentOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSupplierPaymentOrderItemCatalogForAdquisitionContract_Number_java.util.Date", [idSupplierPaymentOrder, supplierPaymentOrderDate]);
    }

    public async addUBLItemInvoiceToAdquisitionArticle(idSupplierPaymentOrderItem: number, supplierPaymentOrderDate: any, idUBLItemInvoice: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLItemInvoice_addUBLItemInvoiceToAdquisitionArticle_Number_java.util.Date_Number", [idSupplierPaymentOrderItem, supplierPaymentOrderDate, idUBLItemInvoice]);
    }

    public async releaseUBLItemInvoiceFromAdquisitionArticle(idUBLInvoice: number, issueDate: any, idAdquisitionContract: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLItemInvoice_releaseUBLItemInvoiceFromAdquisitionArticle_Number_java.util.Date_Number", [idUBLInvoice, issueDate, idAdquisitionContract]);
    }

    public async getRecordBudgetBySupplierPaymentOrder(idSupplierPaymentOrder: number, supplierPaymentOrderDate: any, budgetIDStr: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRecordBudgetBySupplierPaymentOrder_Number_java.util.Date_String", [idSupplierPaymentOrder, supplierPaymentOrderDate, budgetIDStr]);
    }

    public async getRecordBudgetBySupplierPaymentOrder2(idSupplierPaymentOrder: number, supplierPaymentOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRecordBudgetBySupplierPaymentOrder_Number_java.util.Date", [idSupplierPaymentOrder, supplierPaymentOrderDate]);
    }

} 